import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard } from 'styling/GlobalStyles'
import { groputDashboardItems } from 'utils/helpers'
import { IWidget } from 'types/dashboard.interface'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody } from 'pages/HrDashboard/hrLayout.styled'
import { DistributionDonut } from './DistributionDonut'
import { toDonutRows } from './statusMeta'

export const CyclesWidget = ({ modalOpen }: IWidget) => {
  const navigate = useNavigate()
  const { taskCycleStatuses } = useSelector((state: RootState) => state.dashboard)
  const rows = toDonutRows(groputDashboardItems(taskCycleStatuses))

  return (
    <DashboardCard
      width='1fr'
      onClick={() => !modalOpen && navigate('/dashboard/cycles')}
      style={{ height: '100%', cursor: modalOpen ? 'grab' : 'pointer' }}
    >
      <WidgetHeader>
        <WidgetTitle>Cycles</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <DistributionDonut rows={rows} centerLabel='cycles' />
      </WidgetBody>
    </DashboardCard>
  )
}
